var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import useAnimationOrigin from './useAnimationOrigin';
import useTargetScale from './useTargetScale';
export default function useAnimationPosition(visible, originRef, loaded, x, y, width, height, scale, speed, updateEasing) {
    // 延迟更新 width/height
    var _a = __read(useTargetScale(width, height, scale, speed, updateEasing), 3), autoWidth = _a[0], autoHeight = _a[1], autoScale = _a[2];
    // 动画源处理
    var _b = __read(useAnimationOrigin(visible, originRef, loaded, speed, updateEasing), 2), easingMode = _b[0], originRect = _b[1];
    // 计算动画位置
    var T = originRect.T, L = originRect.L, W = originRect.W, H = originRect.H, FIT = originRect.FIT;
    // 偏移量，x: 0, y: 0 居中为初始
    var centerWidth = window.innerWidth / 2;
    var centerHeight = window.innerHeight / 2;
    var offsetX = centerWidth - (width * scale) / 2;
    var offsetY = centerHeight - (height * scale) / 2;
    // 缩略图状态
    var miniMode = easingMode < 3 || easingMode > 4;
    // 有缩略图时，则为缩略图的位置，否则居中
    var translateX = miniMode ? (W ? L : centerWidth) : x + offsetX;
    var translateY = miniMode ? (W ? T : centerHeight) : y + offsetY;
    // 最小值缩放
    var minScale = W / (width * scale) || 0.01;
    // 适应 objectFit 保持缩略图宽高比
    var currentHeight = miniMode && FIT ? autoWidth * (H / W) : autoHeight;
    // 初始加载情况无缩放
    var currentScale = easingMode === 0 ? autoScale : miniMode ? minScale : autoScale;
    var opacity = miniMode ? (FIT ? 1 : 0) : 1;
    return [translateX, translateY, autoWidth, currentHeight, currentScale, opacity, easingMode, FIT];
}
